import React from "react"
import { getStyles, getStyleTag } from "../../styles/dynamicStyles";
import classNames from "classnames";
import { Link } from "react-router";
import { isToko } from "../../scripts/maori";
import ArticleFeature from "../modules/ArticleFeature";
import { default as headerMessages } from "../../messages/header"
import { default as sharedMessages } from "../../messages/index"
import { FormattedMessage } from "react-intl"
import Relay from "react-relay";
import { loopSequence }  from "../../scripts/utils";
import _ from "lodash/collection";
import CollectionImage from "../elements/CollectionImage";

const gridPositionSequence = [
  "grid-top-left",
  "grid-full-right",
  "grid-bottom-left",
  "grid-full-left",
  "grid-top-right",
  "grid-bottom-right"
]
const gridColorSequence = ["1", "2", "3", "4", "5", "6", "7"]

class FeaturedCollections extends React.Component {
  componentDidMount() {
    window.scrollTo(0, 0)
  }

  groupToSize = (collections, size = 3) => {
    const res = collections.reduce(
      ({ grid, index }, collection) => {
        if (grid[index].length >= size) {
          index += 1
          grid[index] = []
        }
        grid[index].push(collection)

        return { grid, index }
      },
      { grid: [[]], index: 0 }
    )

    return res.grid
  }

  render() {
    const { resources_collections: collections } = this.props.viewer

    const collectionGrid = this.groupToSize(collections, 3)
    const gridPositionClassNames = loopSequence(gridPositionSequence)
    const gridColorClassNames = loopSequence(_.shuffle(gridColorSequence))
    const headerImageResource =
      collections.length && "cover_image" in collections[0] ? collections[0].cover_image : null

    return (
      <main id="main" role="main" tabIndex={0}>
        {getStyleTag([
          'rich-page-header__content',
          'c-tabs__tab',
          'c-tabs--pagey__tab'
        ])}
        <div className="rich-page-header state-has-overlap" style={getStyles('rich-page-header')}>
          <CollectionImage
            images={headerImageResource}
            className="rich-page-header__bg"
          />
          <div className="rich-page-header__content mbm"
               style={getStyles('rich-page-header__content')}>
            <div className="row column">
              <h1 className="rich-page-header__title" style={getStyles('rich-page-header__title')}>
                <FormattedMessage {...sharedMessages.featuredCollections} />
              </h1>
            </div>
          </div>
        </div>

        <div className={classNames("c-tabs c-tabs--pagey")}>
          <div className="row column" style={getStyles('c-tabs--pagey')}>
            <nav className="c-tabs__nav">
              <Link
                to="/featured-collections"
                className="c-tabs__tab"
                activeClassName="state-active"
                style={getStyles([
                  'c-tabs__tab',
                  'collections__c-tabs__tab',
                  'c-tabs__tab__active'
                ])}
              >
                <FormattedMessage {...sharedMessages.featuredCollections} />
              </Link>
              <Link
                to="/collections"
                className="c-tabs__tab"
                activeClassName="state-active"
                style={getStyles([
                  'c-tabs__tab',
                  'collections__c-tabs__tab',
                ])}
              >
                <FormattedMessage {...headerMessages.collections} />
              </Link>
              <Link
                to="/sets"
                className="c-tabs__tab"
                activeClassName="state-active"
                style={getStyles([
                  'c-tabs__tab',
                  'collections__c-tabs__tab'
                ])}
              >
                <FormattedMessage {...sharedMessages.communitySets} />
              </Link>
            </nav>
          </div>
          {collectionGrid.map((collections, i) => (
            <div
              key={i}
              className="showcase-grid showcase-grid--repeating showcase-grid--wideflags"
              style={i === 0 ? getStyles('showcase-grid--wideflags') : null}
            >
              {collections.map((collection, i) => {
                const totalItems = collection.collected.total
                const toko = isToko(totalItems)

                return (
                  <ArticleFeature
                    key={`${collection.id}-${i}`}
                    className={
                      "showcase-grid__item--" +
                      gridPositionClassNames() +
                      " showcase-grid__item--color-" +
                      gridColorClassNames()
                    }
                    resource={collection}
                    images={collection.cover_image}
                    to={`/collections/${collection.slug}`}
                    page="collections"
                  >
                    <div style={getStyles('collections__showcase-grid__item__description')}>
                      {collection.description && (
                        <p className="mbn">{collection.description}</p>
                      )}
                      <strong className="extrabold text-underline">
                        {toko && (
                          <FormattedMessage
                            {...sharedMessages.numberOfItems}
                            values={{ count: totalItems }}
                          />
                        )}
                        {!toko && (
                          <FormattedMessage
                            {...sharedMessages.numberOfItemsE}
                            values={{ count: totalItems }}
                          />
                        )}
                      </strong>
                    </div>
                  </ArticleFeature>
                )
              })}
            </div>
          ))}
        </div>
      </main>
    )
  }
}

export default Relay.createContainer(FeaturedCollections, {
  fragments: {
    viewer: () => Relay.QL`
      fragment on Viewer {
        resources_collections(highlighted: true) {
          id
          slug
          title
          description
          collected {
            total
          }
          cover_image {
            small {
              url
              width
              height
              mime_type
            }
            medium {
              url
              width
              height
              mime_type
            }
            large {
              url
              width
              height
              mime_type
            }
          }
        }
      }
    `
  }
})



// WEBPACK FOOTER //
// ./webapp/components/pages/FeaturedCollections.js